// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"508":"4534323d","669":"6de0ecf2","677":"bda93d13"}[chunkId] + ".chunk.css";
};